<template>
	<div class="detail">
		<div class="title">
			{{info.name}}
		</div>
		<div class="image">
			<img :src="$pub.imageUrl+info.image" alt="">
			<div>
				<span>分辨率：{{info.ratio}}</span>
				<i class="el-icon-download" @click="download"></i>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'detail',
		data() {
			return {
				info: {
					name: '',
					image: '',
					ratio: ''
				},
				id: ''
			};
		},
		methods: {
			fetchData() {
				this.$api.frontAutionDetail({
					id: this.id,
				}, res => {
					if (res.code == 200) {
						this.info = {
							name: res.data.lotName,
							image: res.data.lotPictrueUrl,
							ratio: ''
						}
					}
				})
			},
			download() {
				let alink = document.createElement("a");
				alink.href = this.info.image
				alink.download = this.info.name
				alink.target = '_blank'
				alink.click()
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
			this.id = this.$route.query.id
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchData()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.title {
		width: 100%;
		padding: 20px 0px;
		line-height: 36px;
		font-size: @vue-font-size-base;
		text-align: center;
		border-bottom: 1px solid @vue-border-color-red;
	}

	.image {
		width: 100%;
		margin-top: @vue-spacing-col-lg * 2;
		position: relative;

		img {
			width: 100%;
			display: block;
		}

		div {
			width: 100%;
			height: 50px;
			background: @vue-bg-color-mask;
			color: @vue-text-color-inverse;
			position: absolute;
			bottom: 0px;
			left: 0px;
			z-index: 99;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: @vue-font-size-base - 4;
			padding: 0px @vue-spacing-row-lg;
			box-sizing: border-box;
		}
	}
</style>
